<template>
  <div class="flex flex-col space-y-1">
    <div class="grid grid-cols-2 gap-1.5">
      <button
        v-for="src in availableSources"
        :key="src.value"
        :class="[
          'flex cursor-pointer flex-col items-center rounded p-1 transition-colors',
          isSelected(src.value) ? 'bg-primary-600 text-primary-950 font-semibold shadow-lg' : '',
        ]"
        :disabled="disabled"
        @click="select(src.value)">
        <img v-if="previews[src.value]" :src="previews[src.value]" class="aspect-video w-full rounded-sm" />
        <span class="mt-0.5 w-full truncate text-center text-[10px]">
          {{ src.label }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { inputSources, legacyNameMap } from '@/threejs/canvas-patterns';
import { computed, onMounted, reactive } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  sources: {
    type: Array,
    default: () => Object.keys(inputSources),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const previews = reactive({});

const availableSources = computed(() => {
  return props.sources.map((key) => inputSources[key]).filter(Boolean);
});

function isSelected(value) {
  const resolved = legacyNameMap[props.modelValue] || props.modelValue;
  return resolved === value;
}

function select(value) {
  if (!props.disabled) {
    emit('update:modelValue', value);
  }
}

function generatePreviews() {
  const canvas = document.createElement('canvas');
  canvas.width = 128;
  canvas.height = 72;
  const ctx = canvas.getContext('2d');

  for (const src of availableSources.value) {
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      src.draw(ctx, canvas.width, canvas.height);
      previews[src.value] = canvas.toDataURL('image/png');
    }
  }
}

onMounted(() => {
  generatePreviews();
});
</script>
